import { IconButton } from '@mui/material';
import { useState } from 'react';
import MaritimeDirectoryPortsEditor from '../MaritimeDirectoryPortEditor/MaritimeDirectoryPortsEditor';
import { counterPartyModel } from 'model';
import SettingsIcon from '@mui/icons-material/Settings';

interface CounterPartyMaritimeDirectoryPortEditorButtonProps {
  counterParty: Partial<counterPartyModel>;
  maritimeDirectoryId: string;
  refetch: () => void;
}

const CounterPartyMaritimeDirectoryPortEditorButton = (props: CounterPartyMaritimeDirectoryPortEditorButtonProps) => {
  const [showEditor, setShowEditor] = useState(false);

  const toggleEditor = () => setShowEditor((prev) => !prev);

  return (
    <>
      {showEditor ? (
        <MaritimeDirectoryPortsEditor
          counterParty={props.counterParty}
          maritimeDirectoryId={props.maritimeDirectoryId}
          onClose={toggleEditor}
          onUpdated={props.refetch}
        />
      ) : null}
      <IconButton color="primary" onClick={toggleEditor}>
        <SettingsIcon />
      </IconButton>
    </>
  );
};

export default CounterPartyMaritimeDirectoryPortEditorButton;
